export default function clearbitLogoFromDomain(domain: string): string {
  return `//logo.clearbit.com/${domain}`
}
